const LOCAL_STORAGE_KEY = 'upwex_dev_extension_id';

/**
 * Returns the extension ID to use for chrome.runtime.sendMessage.
 * In development: checks localStorage override first, then falls back to env var.
 * In production: always returns env var.
 */
export function getExtensionId(): string | undefined {
  if (process.env.REACT_APP_DEV_MODE === 'true') {
    const devId = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (devId) return devId;
  }
  return process.env.REACT_APP_EXTENSION_ID;
}

/** Save a dev extension ID override to localStorage. */
export function saveDevExtensionId(id: string): void {
  localStorage.setItem(LOCAL_STORAGE_KEY, id);
}

/** Read the current dev override (or empty string if none). */
export function getDevExtensionId(): string {
  return localStorage.getItem(LOCAL_STORAGE_KEY) || '';
}
